import Settings from "@mui/icons-material/Settings";
import { IconButton, Popover, Tooltip } from "@mui/material";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useCallback, useState } from "react";

import { ScoutWriteAccessToggle } from "./Chat/ScoutWriteAccessToggle";

export type ScoutConversationSettingsMenuProps = {
  allowMutations: boolean;
  onAllowMutationsChange: (next: boolean) => void;
  disabled?: boolean;
  iconButtonSize?: "small" | "medium" | "large";
};

export function ScoutConversationSettingsMenu({
  allowMutations,
  onAllowMutationsChange,
  disabled = false,
  iconButtonSize = "medium",
}: ScoutConversationSettingsMenuProps) {
  const { featureFlags } = useFeatureFlags();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  if (!featureFlags?.[FeatureFlagKey.ScoutWriteAccess]) {
    return null;
  }

  return (
    <>
      <Tooltip title="Conversation settings">
        <IconButton
          size={iconButtonSize}
          onClick={handleOpen}
          aria-label="Conversation settings"
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <Settings />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: { mt: 0.5, minWidth: 280 },
          },
        }}
      >
        <ScoutWriteAccessToggle
          variant="menu"
          value={allowMutations}
          disabled={disabled}
          onChange={onAllowMutationsChange}
        />
      </Popover>
    </>
  );
}
